<template>
  <div class="bear-upload-dialog">
    <el-button type="primary" @click="uploadDialog" :disabled="!isEdit || modelValue.length == maxLimit">上传</el-button>
    <bear-file-list :file-list="modelValue" @del-file="delFile" :is-edit="isEdit"></bear-file-list>
    <el-dialog v-model="uploadDlgVisible" custom-class="dlg-upload" width="800px" :close-on-click-modal="false" append-to-body>
      <el-upload
        v-loading="loading"
        ref="upload"
        :accept="accept"
        :action="fileServer"
        :auto-upload="false"
        :multiple="false"
        :data="data"
        :on-change="handleChange"
        :on-success="success"
        :on-before="beforeUpload">
        <template #trigger>
          <el-button class="btn-upload-select" type="primary">选取文件</el-button>
        </template>
        <template #default>
          <el-button class="btn-upload-server" type="success" @click="submitUpload">上传到服务器</el-button>
        </template>
      </el-upload>
    </el-dialog>
  </div>
</template>
<script>
import SparkMD5 from "spark-md5";
import { mapActions, mapState, mapGetters } from "vuex";
import BearFileList from "../../file-list/src";

export default {
  name: "BearUploadDialog",
  components: {
    BearFileList,
  },
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      },
    },
    accept: String,
    drag: Boolean,
    withCredentials: Boolean,
    maxLimit: {
      default: 999,
    },
  },
  computed: {
    ...mapState(["fileServer"]),
    ...mapGetters(["isEdit"]),
  },
  data() {
    return {
      uploadDlgVisible: false,
      loading: false,
      data: {
        key: "",
        token: "",
      },
    };
  },
  methods: {
    uploadDialog() {
      this.uploadDlgVisible = true;
    },
    handleFileSelect() {
      console.log("选择文件");
    },
    handleChange(file, uploadFiles) {
      let { accept } = this;
      let { raw, name } = file;
      if (accept === ".xml" && name.slice(-4).toLowerCase() !== ".xml") {
        return this.$message.info("请选择xml文件进行上传");
      }
      if (raw.md5 || raw.token) {
        // 若是已经读取MD5码，则跳过
      } else {
        this.loading = true;
        let instanceOfBlob = new Blob([raw], { type: "" });
        let chunkSize = 2097152;
        let chunkCount = Math.ceil(file.size / chunkSize);
        let currentChunk = 0;
        let spark = new SparkMD5.ArrayBuffer();
        let fileReader = new FileReader();

        const loadNext = () => {
          let start = currentChunk * chunkSize;
          let end = start + chunkSize;
          if (end >= file.size) {
            end = file.size;
          }
          let chunk = instanceOfBlob.slice(start, end);
          fileReader.readAsArrayBuffer(chunk);
        };

        fileReader.onload = (e) => {
          let { result } = e.target;
          spark.append(result);
          currentChunk++;
          if (currentChunk < chunkCount) {
            loadNext();
          } else {
            let md5 = spark.end().toUpperCase();
            file.raw.md5 = md5;
            this.setFileToken(file);
          }
        };

        loadNext();
      }
    },
    setFileToken(file) {
      let { data } = this;
      let { size, raw } = file;
      this.requestFileToken(raw)
        .then((res) => {
          this.loading = false;
          let { uptoken } = res;
          let guid = `${Date.now()}${this.getFileType(raw)}${size}`;
          let key = `${guid}/${raw.name}`;
          data.key = raw.key = key;
          data.token = raw.token = uptoken;
        })
        .catch(() => {
          this.loading = false;
          this.$messager.error("获取上传文件令牌失败！请联系客服");
        });
    },
    getFileType(file) {
      let { name } = file;
      let index = name.lastIndexOf(".");
      return name.slice(index + 1);
    },
    submitUpload() {
      this.loadign = true;
      this.$refs.upload.submit();
    },
    success(res) {
      this.loading = false;

      this.modelValue.push(res);
      this.$emit("update:modelValue", this.modelValue);
      this.$emit("input", res);
    },
    beforeUpload(file) {
      this.loading = true;
      this.data.key = file.key;
      this.data.token = file.token;
    },
    delFile(i) {
      this.modelValue.splice(i, 1);
      if (this.maxLimit == 1) {
        this.$emit("input", false);
      } else {
        this.$emit("update:modelValue", this.modelValue);
        this.$emit("input");
      }
    },
    ...mapActions(["requestFileToken"]),
  },
};
</script>
<style lang="scss" scoped>
.btn-upload-select,
.btn-upload-server {
  margin-right: 10px;
}
</style>
<style lang="scss">
.tender-form-item {
  .is-error {
    .bear-upload-dialog {
      .el-button--primary {
        background: red;
        border: 1px solid red;
      }
      .el-form-item__error {
        display: none;
      }
    }
  }
}
</style>
